import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { messages } from './messages.tsx';
import type { Status } from './types.tsx';

export const getStatus = (formatMessage: FormatMessage): Status => ({
	Open: {
		ogStatus: formatMessage(messages.openNonFinal),
		jiraStatus: formatMessage(messages.pendingNonFinal),
		lozengeContent: formatMessage(messages.pendingNonFinal),
		appearance: 'inprogress',
	},
	Resolve: {
		ogStatus: formatMessage(messages.resolveNonFinal),
		jiraStatus: formatMessage(messages.investigateNonFinal),
		lozengeContent: formatMessage(messages.workInProgressNonFinal),
		appearance: 'inprogress',
	},
	Close: {
		ogStatus: formatMessage(messages.closeNonFinal),
		jiraStatus: formatMessage(messages.cancelNonFinal),
		lozengeContent: formatMessage(messages.canceledNonFinal),
		appearance: 'success',
	},
	Delete: {
		ogStatus: formatMessage(messages.deleteNonFinal),
		jiraStatus: formatMessage(messages.resolveNonFinal),
		lozengeContent: formatMessage(messages.completedNonFinal),
		appearance: 'success',
	},
});
